import { DownIcon8px, UpIcon8px } from '~/presentation/icons';
import { InlineStack, Text } from '@shopify/polaris';
import { cls, formatPercentage } from '~/utils';

export interface IncreasePercentageProps {
  increase: number | string;
  /** True for "lower is better" metrics (e.g. bounce rate): swaps which direction is colored good/bad. */
  isReverse?: boolean;
}

export const IncreasePercentage: React.FC<IncreasePercentageProps> = ({ increase, isReverse }) => {
  if (typeof increase !== 'number') {
    return <div className="w-[11px] h-[2px] bg-[#8A8A8A]" />;
  }
  const isGood = isReverse ? increase < 0 : increase > 0;
  const color = isGood ? '#007F5F' : '#4A4A4A';
  return (
    <div
      className={cls(`flex items-center gap-[4px] rounded-lg text-bodySm w-fit max-h-[20px]`, {
        '!text-[#007F5F]': isGood,
        '!text-[#4A4A4A]': !isGood,
      })}
    >
      {increase < 0 && (
        <InlineStack align="center">
          <DownIcon8px color={color} />
        </InlineStack>
      )}
      {increase > 0 && (
        <InlineStack align="center">
          <UpIcon8px color={color} />
        </InlineStack>
      )}
      <Text as="span" variant="bodyXs" fontWeight="semibold">
        {formatPercentage(Math.abs(increase || 0))}
      </Text>
    </div>
  );
};
